import * as React from "react";
import AutoOcrSidebar from "./AutoOcrSidebar";
import {
  GetAutoOcrDocumentTypeList,
  GetAutoOcrFieldList,
  GetAutoOcrFieldMapping,
  UpdateAutoOcrMapping,
  GetAutoOcrFieldMappingDocumentType
} from "../../../../actions/AutoOcrActions";
import {
  LoadFormType
} from "../../../../actions/FormTypeActions";
import AutoOcrStore from "../../../../stores/AutoOcrStore";
import FormTypeStore from "../../../../stores/FormTypeStore";
import actionTypes from "../../../../actions/ActionTypes";
class AutoOcrMappingView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentFormType: void 0,
      currentDocTypeId: 0,
      currentDocTypeName: "",
      isDirty: false,
      isSecOneSaving: false,
      errorOne: "",
      autoOcrFields: [],
      selectedDocumentTypeId: 0,
      documentTypes: [],
      autoOcrFieldMappingList: []
    };
    this.updateMappings = this.updateMappings.bind(this);
    this.onFormTypeStoreUpdate = this.onFormTypeStoreUpdate.bind(this);
    this.save = this.save.bind(this);
    this.editSelectedDocumentType = this.editSelectedDocumentType.bind(this);
    this.onAutoOcrStoreUpdate = this.onAutoOcrStoreUpdate.bind(this);
    this.addNewFieldMapping = this.addNewFieldMapping.bind(this);
    this.editExistingFieldMapping = this.editExistingFieldMapping.bind(this);
    this.deleteFieldMapping = this.deleteFieldMapping.bind(this);
    this.removeAll = this.removeAll.bind(this);
  }
  componentDidMount() {
    FormTypeStore.addChangeListener(this.onFormTypeStoreUpdate);
    AutoOcrStore.addChangeListener(this.onAutoOcrStoreUpdate);
    this.updateMappings();
    GetAutoOcrDocumentTypeList();
  }
  componentWillUnmount() {
    FormTypeStore.removeChangeListener(this.onFormTypeStoreUpdate);
    AutoOcrStore.removeChangeListener(this.onAutoOcrStoreUpdate);
  }
  componentDidUpdate() {
    this.updateMappings();
  }
  updateMappings() {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let formTypeId = parseInt(pathParts[pathParts.length - 1], 10);
    if (formTypeId !== 0 && (this.state.currentDocTypeId === void 0 || this.state.currentDocTypeId !== formTypeId)) {
      this.setState({ currentDocTypeId: formTypeId });
      LoadFormType(formTypeId);
      GetAutoOcrFieldMapping(formTypeId);
      GetAutoOcrFieldMappingDocumentType(formTypeId);
    }
  }
  onFormTypeStoreUpdate() {
    let lastAction = FormTypeStore.getLastAction();
    if (lastAction.actionType === "FTLoad") {
      let currentFT = FormTypeStore.getCurrentFT();
      this.setState({
        currentFormType: currentFT
      });
    }
  }
  onAutoOcrStoreUpdate() {
    let lastAction = AutoOcrStore.lastChange();
    if (lastAction === actionTypes.AutoOcrFieldGetList) {
      let fields = AutoOcrStore.getFields();
      this.setState({
        autoOcrFields: fields
      });
    }
    if (lastAction === actionTypes.AutoOcrMappingList) {
      let mappings = AutoOcrStore.getMappings();
      this.setState({
        autoOcrFieldMappingList: mappings
      });
    }
    if (lastAction === actionTypes.AutoOcrMappingDocumentType) {
      let currentDocType = AutoOcrStore.getCurrentDocumentTypes();
      this.setState({
        selectedDocumentTypeId: currentDocType.id
      });
      GetAutoOcrFieldList(currentDocType.id);
    }
    if (lastAction === actionTypes.AutoOcrDocumentTypeGetList) {
      let docTypes = AutoOcrStore.getDocumentTypes();
      this.setState({
        documentTypes: docTypes
      });
    }
  }
  save() {
    this.setState({ isDirty: false });
    UpdateAutoOcrMapping(this.state.autoOcrFieldMappingList, this.state.currentFormType.formTypeId);
  }
  removeAll() {
    this.setState({ selectedDocumentTypeId: 0, autoOcrFieldMappingList: [], isDirty: true });
    GetAutoOcrFieldList(0);
  }
  addNewFieldMapping(value, field) {
    var fieldMapping = {
      id: 0,
      formTypeId: this.state.currentFormType.formTypeId,
      ocrFieldId: parseInt(value),
      documentFieldId: field.fieldId
    };
    var list = this.state.autoOcrFieldMappingList;
    list.push(fieldMapping);
    this.setState({ autoOcrFieldMappingList: list, isDirty: true });
  }
  editExistingFieldMapping(value, field) {
    var indexOfObject = this.state.autoOcrFieldMappingList.findIndex((object) => {
      return object.documentFieldId === field.fieldId;
    });
    var list = this.state.autoOcrFieldMappingList;
    list[indexOfObject].ocrFieldId = parseInt(value);
    this.setState({ autoOcrFieldMappingList: list, isDirty: true });
  }
  editSelectedDocumentType(event) {
    this.setState({ selectedDocumentTypeId: event.target.value, autoOcrFieldMappingList: [], isDirty: true });
    GetAutoOcrFieldList(event.target.value);
  }
  deleteFieldMapping(field) {
    var list = this.state.autoOcrFieldMappingList.filter((x) => x.documentFieldId !== field.fieldId);
    this.setState({ autoOcrFieldMappingList: list, isDirty: true });
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "container-fluid", style: { height: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "row flex-nowrap", style: { height: "100%" } }, /* @__PURE__ */ React.createElement(AutoOcrSidebar, null), /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "flex-fill",
        style: { backgroundColor: "#efefef", overflow: "scroll" }
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card",
          style: {
            marginTop: "20px",
            marginLeft: "30px",
            marginRight: "30px"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header", key: "header" }, /* @__PURE__ */ React.createElement("div", { className: "mt-3 fw-bold fs-5" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-wand-magic" }), "  ", this.state.currentFormType !== void 0 && /* @__PURE__ */ React.createElement("span", { style: { fontSize: "14pt" } }, this.state.currentFormType.name), /* @__PURE__ */ React.createElement("div", { className: "mb-3", style: { float: "right" } }, /* @__PURE__ */ React.createElement("div", null, this.state.isDirty && /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-primary",
            onClick: this.save
          },
          "Save"
        ), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-danger",
            style: { marginLeft: "6px" },
            onClick: this.removeAll
          },
          "Remove all"
        )), this.state.isSecOneSaving && /* @__PURE__ */ React.createElement("i", { className: "fas fa-spinner fa-spin fa-2x" }), this.state.errorOne !== "" && /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "alert alert-danger",
            style: { marginTop: "6px" },
            role: "alert"
          },
          this.state.errorOne
        )))),
        /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "" }, /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select",
            value: this.state.selectedDocumentTypeId,
            onChange: this.editSelectedDocumentType
          },
          /* @__PURE__ */ React.createElement("option", { value: "0" }),
          this.state.documentTypes.map((docType) => /* @__PURE__ */ React.createElement(
            "option",
            {
              value: docType.id,
              key: docType.id
            },
            docType.name
          ))
        ), /* @__PURE__ */ React.createElement("div", { className: "row pt-3 fw-bold fs-6 text-center" }, /* @__PURE__ */ React.createElement("div", { className: "col-3" }, "TrinDocs Header Field"), /* @__PURE__ */ React.createElement("div", { className: "col-3 fw-bold fs-6 text-center" }, "Auto Ocr Field")), this.state.currentFormType !== void 0 && this.state.currentFormType.fieldSets.filter((a) => a.name === "Header")[0].fields.map((field) => /* @__PURE__ */ React.createElement("div", { className: "row", key: `field-${field.fieldId}` }, /* @__PURE__ */ React.createElement("div", { className: "col-3 pt-2" }, /* @__PURE__ */ React.createElement(
          "span",
          {
            value: field.name,
            key: field.fieldId,
            className: ""
          },
          field.name
        )), /* @__PURE__ */ React.createElement(React.Fragment, null, this.state.autoOcrFieldMappingList.filter((x) => x.documentFieldId === field.fieldId).length > 0 && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: "col-3 pt-2" }, /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select",
            value: this.state.autoOcrFieldMappingList.filter((x) => x.documentFieldId === field.fieldId)[0].ocrFieldId,
            onChange: (event) => this.editExistingFieldMapping(event.target.value, field)
          },
          /* @__PURE__ */ React.createElement("option", { value: "0" }),
          this.state.autoOcrFields.map((field2) => /* @__PURE__ */ React.createElement(
            "option",
            {
              value: field2.id,
              key: "mapping-" + field2.id
            },
            field2.name
          ))
        )), /* @__PURE__ */ React.createElement("div", { className: "col-2 mt-2" }, field.fieldId > -1 && /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-danger ms-2",
            onClick: () => {
              this.deleteFieldMapping(field);
            }
          },
          "Delete"
        )))), this.state.autoOcrFieldMappingList.filter((x) => x.documentFieldId === field.fieldId).length <= 0 && /* @__PURE__ */ React.createElement("div", { className: "col-3 pt-2" }, /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "form-select",
            value: 0,
            onChange: (event) => this.addNewFieldMapping(event.target.value, field)
          },
          /* @__PURE__ */ React.createElement("option", { value: "0" }),
          this.state.autoOcrFields.map((field2) => /* @__PURE__ */ React.createElement(
            "option",
            {
              value: field2.id,
              key: "mapping-" + field2.id
            },
            field2.name
          ))
        ))))))))
      )
    )));
  }
}
export default AutoOcrMappingView;
